import { getQueryVariable } from '../../utils/getQueryVariable'
import { replaceHref } from '../../utils/useNavigateWithAbsoluteURLs/windowHelpers'
import { logOut } from '../features/auth/asyncActions'
import { selectFidelityLogout } from '../features/config/selectors'
import { useRouter } from '../router/useRouter'
import { useAppDispatch, useAppSelector } from '../store'

/**
 * logout(withSingleLogout = true)
 * withSingleLogout:
 *  - defaults to true; when a single-logout URL is configured, redirects the
 *    browser to it after local logout so the IdP session is terminated too.
 *    The redirect is a top-level navigation because the endpoint is a SAML
 *    front-channel SLO flow that a background fetch cannot drive.
 * */
export const useLogout = () => {
  const dispatch = useAppDispatch()
  const { navigate } = useRouter()
  const { enableSingleLogout, singleLogoutUrl } = useAppSelector(selectFidelityLogout)
  const startSignIn = getQueryVariable('startSignIn')

  return {
    logout: async ({ withSingleLogout } = { withSingleLogout: true }) => {
      dispatch(
        logOut(() => {
          if (enableSingleLogout && withSingleLogout && singleLogoutUrl) {
            replaceHref(singleLogoutUrl)
          } else {
            navigate({ pathname: '/', ...(startSignIn ? { query: { startSignIn } } : {}) })
          }
        })
      )
    },
  }
}
